export default __webpack_public_path__ + "static/media/otsukare@2x.66c5e2cf.png";